/**
 * InfoCell.jsx — AIRGROW Material Interface
 * ラベル付き詳細セル（ドロワー・カード内の情報表示用）
 *
 * 使い方:
 *   <InfoCell label="組織名">{orgName}</InfoCell>          // children モード
 *   <InfoCell label="機体重量" value={info.weight} />      // value モード（null/undefined → "—"）
 */
import React from 'react';
import { C } from '../../ColorTokens';

export default function InfoCell({ label, value, children }) {
  const usingChildren = children != null;
  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.72)',
        borderRadius: 14,
        border: `1px solid ${C.outlineVariant}`,
        padding: '12px 16px',
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          color: C.outline,
          marginBottom: 4,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: 14,
          fontWeight: 500,
          color: usingChildren || value ? C.onSurface : C.outlineVariant,
        }}
      >
        {usingChildren ? children : (value || '—')}
      </div>
    </div>
  );
}
